if (!customElements.get('search-suggestions')) {
  const SearchSuggestions = class extends HTMLElement {
    connectedCallback() {
      this.searchTimeoutID = -1;
      this.searchInput = this.closest('form').querySelector('input[name="q"]');
      this.searchInput.addEventListener('keyup', this.handleInputChange.bind(this));
      this.searchInput.addEventListener('change', this.handleInputChange.bind(this));
    }

    handleInputChange() {
      const valueToSearch = this.searchInput.value;

      if (valueToSearch.length && valueToSearch !== this.oldSearchValue) {
        clearTimeout(this.searchTimeoutID);

        this.searchTimeoutID = setTimeout(() => {
          this.fetchSuggestions(valueToSearch);
        }, 500);
      } else if (!valueToSearch.length) {
        clearTimeout(this.searchTimeoutID);

        if (this.searchSuggestionsAbortController) {
          this.searchSuggestionsAbortController.abort('Existing request not needed');
          this.searchSuggestionsAbortController = null;
        }

        this.innerHTML = '';
      }

      this.oldSearchValue = valueToSearch;
    }

    fetchSuggestions(terms) {
      if (this.searchSuggestionsAbortController) {
        this.searchSuggestionsAbortController.abort('Existing request not needed');
      }
      this.searchSuggestionsAbortController = new AbortController();

      // Shopify's Predictive Search API does not support Arabic as a buyer
      // locale: /search/suggest answers HTTP 417 "Unsupported buyer locale", so
      // Arabic shoppers got no suggestions at all. The regular /search route
      // does work in Arabic, so fall back to it and render our own section.
      const isArabic = (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const url = isArabic
        ? `${root}search?q=${encodeURIComponent(terms)}&type=product&section_id=hewyn-search-fallback`
        : `/search/suggest?q=${encodeURIComponent(terms)}&section_id=search-suggestions`;

      fetch(url, {
        signal: this.searchSuggestionsAbortController.signal
      })
        .then((response) => {
          // A 417 can also hit English pages when the session's buyer locale is Arabic.
          if (!response.ok && !isArabic) {
            return fetch(`${root}search?q=${encodeURIComponent(terms)}&type=product&section_id=hewyn-search-fallback`, {
              signal: this.searchSuggestionsAbortController.signal
            });
          }
          return response;
        })
        .then((response) => {
          if (!response.ok) {
            throw new Error(response.status);
          }
          return response.text();
        })
        .then((text) => {
          const results = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.search-suggestions-wrapper');

          this.innerHTML = '';
          if (results && results.firstElementChild) {
            this.insertAdjacentElement('beforeend', results.firstElementChild);
          }
        })
        .catch((error) => {
          console.warn(error);
          if (error.code === 20) {
            return; // aborted
          }
          throw error;
        });
    }
  };

  window.customElements.define('search-suggestions', SearchSuggestions);
}
